















import { Component, Prop } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
// import pathologicdiagnosis from "./pathologicdiagnosis/index.vue";
import pathologicdiagnosis from "./pathologicdiagnosis2/index.vue";
@Component({
  components: {
    pathologicdiagnosis,
  },
})
export default class extends AbpBase {
  @Prop({ type: Boolean }) value: boolean;
  @Prop() data: any;
  tab = "1";
  theme = "light";
  infoWidth = 1400;

  tabChange(val1: any, val2: any) {
    this.tab = val1;
  }

  get dialogTitle() {
    return this.data.name;
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }

  mounted() {
    let width = document.body.offsetWidth;
    this.infoWidth = width - 55 - 244;
  }

  getHomeSuccess() {
    this.$emit("save-success");
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pathologyManage/parts/patientInfo.vue